import Head from "../shopElements/head";
import Search from "../newShop/search";
import Categories from "../newShop/categories";
import Products from "../newShop/products";
import MarketingCarousel from "../newShop/marketingCarousel";
import EducationMaketing from "../newShop/educationMaketing";
import Sort from "../newShop/sortby";
import "../newShop/newShop.css";
import "../newShop/categories.css";
import { useState,useEffect } from "react";
import { Helmet } from "react-helmet";
function NewShop(props) {
  const [smartHome, setSmartHome] = useState(false);
  const [kits, setKits] = useState(false);
  const [automatisme, setAutomatisme] = useState(false);
  const [carte, setCarte] = useState(true);
  const [Robotique, setRobotique] = useState(false);
  const [iot, setIot] = useState(false);
  const [Drone, setDrone] = useState(false);
  const [Machines, setMachines] = useState(false);
  const [Modules, setModules] = useState(false);
  const [Capteurs, setCapteurs] = useState(false);
  const [MoteursAndDivers, setMoteursAndDivers] = useState(false);
  const [Afficheurs, setAfficheurs] = useState(false);
  const [électronique, setElectronique] = useState(false);
  const [connecteurs, setConnecteurs] = useState(false);
  const [alimentation, setAlimentation] = useState(false);
  const [outillages, setOutillages] = useState(false);
//  const [category, setCategory] = useState("Cartes de développement");
  const [category, setCategory] = useState("Découvrer Nos Produits");
 const [searched , setSearch] = useState([]);
 const [empty , setEmpty] = useState([]);
 const [matchingProducts , setMatchingProducts] = useState([]);
 const [windowDimenion, detectHW] = useState({
  winWidth: window.innerWidth,
  winHeight: window.innerHeight,
});
const detectSize = () => {
  detectHW({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
};
function getMatchingProducts(value){
  setMatchingProducts(value);
}
useEffect(() => {
  window.addEventListener("resize", detectSize);


  return () => {
    window.removeEventListener("resize", detectSize);
  };
}, [windowDimenion]);
if(windowDimenion.winWidth > 800){
   return (
    <div style={{ overflowX: "hidden" }}>
          <Helmet>
        <title>Maker Shop</title>
        <meta
          name="description"
          content="We provide at maker Skills Up a variety of educational robotic kits, electronics tools, IT equipments and a lot more."
        />
        <meta
          name="keywords"
          content="electronic kit , material , robotics , maker shop , e-commerce , drone , IT equipment"
        />
      </Helmet>
      <Head type={"shop"} />
      <div className="inlineItems">
        <div>
          <Categories
            carte={carte}
            setCategory={setCategory}
            setCarte={setCarte}
            Robotique={Robotique}
            setRobotique={setRobotique}
            iot={iot}
            setIot={setIot}
            Drone={Drone}
            setDrone={setDrone}
            smartHome={smartHome}
            setSmartHome={setSmartHome}
            kits={kits}
            setKits={setKits}
            automatisme={automatisme}
            setAutomatisme={setAutomatisme}
            Modules={Modules}
            setModules={setModules}
            Machines={Machines}
            setMachines={setMachines}
            setCapteurs={setCapteurs}
            Capteurs={Capteurs}
            setAfficheurs={setAfficheurs}
            Afficheurs={Afficheurs}
            setElectronique={setElectronique}
            électronique={électronique}
            setConnecteurs={setConnecteurs}
            connecteurs={connecteurs}
            setAlimentation={setAlimentation}
            alimentation={alimentation}
            setOutillages={setOutillages}
            outillages={outillages}
            MoteursAndDivers={MoteursAndDivers}
            setMoteursAndDivers={setMoteursAndDivers}
            category={category}
          />
        </div>
       <div className="searchBarPlace">
       <Search setEmpty={setEmpty} setSearch={setSearch} getMatchingProducts={getMatchingProducts}/>
       </div>
        {/* <Sort /> */}
      </div>
      {/* <div className="educationMarketingTitle">
        Nous proposons des formations pratiques liés à l'utilisation de nos
        produits. <br/> Allez-y ! Jetez un coup d'œil sur nos prochains ateliers !
      </div> */}
      <MarketingCarousel/>
      <EducationMaketing/>
      <Products empty={empty} search={searched} appear={"yes"} category={category} setId={props.setId} matchingProducts={matchingProducts}/>
    </div>
  );} else{
    return <div style={{ overflowX: "hidden" }}>
    <Head type={"shop"} />
    <div className="inlineItems">
      <div>
   
      </div>
      <Search setEmpty={setEmpty} setSearch={setSearch} getMatchingProducts={getMatchingProducts} />
      <Sort />
    </div>
    <Categories
          carte={carte}
          setCategory={setCategory}
          setCarte={setCarte}
          Robotique={Robotique}
          setRobotique={setRobotique}
          smartHome={smartHome}
          setSmartHome={setSmartHome}
          kits={kits}
          setKits={setKits}
          automatisme={automatisme}
          setAutomatisme={setAutomatisme}
          iot={iot}
          setIot={setIot}
          Drone={Drone}
          setDrone={setDrone}
          Machines={Machines}
          setMachines={setMachines}
          Modules={Modules}
          setModules={setModules}
          setCapteurs={setCapteurs}
          setAfficheurs={setAfficheurs}
          Afficheurs={Afficheurs}
          Capteurs={Capteurs}
          setElectronique={setElectronique}
          électronique={électronique}
          MoteursAndDivers={MoteursAndDivers}
          setMoteursAndDivers={setMoteursAndDivers}
          setConnecteurs={setConnecteurs}
          connecteurs={connecteurs}
          setAlimentation={setAlimentation}
          alimentation={alimentation}
          setOutillages={setOutillages}
          outillages={outillages}
          category={category}
        />
     
       
    <Products empty={empty} search={searched} appear={"no"} category={category} setId={props.setId} matchingProducts={matchingProducts} />

  </div>
  }
}
export default NewShop;
